import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import { DropdownButton, Dropdown } from "react-bootstrap";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import PollIcon, { HEADING_LIVEQA } from "PollIcon";
import NoContent, { NO_PUBLISHED_QA, NO_UNPUBLISHED_QA } from "NoContent";
import {
  published,
  fetchLiveQA,
  fetchUnpublishedLiveQA,
  markBulkImportant,
  markBulkUnimportant,
  markAllImportant,
  markAllUnimportant,
  markBulkUnpub,
  markAllUnpub,
  markBulkPub,
  markAllPub,
  updateLiveQAList,
} from "LiveQAAction";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  IMAGE_PATH,
  itemCount,
  COMMON_FAIL_MESSAGE,
  screenHeightLeftFromTop,
} from "Constants";
import LiveQAList from "./live-qa-list";
import AddLiveQA from "./add-liveqa";
import BroadCastLiveQA from "./broadcast-live-qa";
import ExportLiveQA from "ExportLiveQA";
import Loader from "Loader";
import LocaleStrings from "Languages";

// userd for sort content list
const DragHandle = sortableHandle(({}) => (
  <span className="drag-icon" style={{ cursor: "move" }}>
    <i className="fa fa-bars mx-6" aria-hidden="true"></i>
  </span>
));

var SortableItem = SortableElement(
  ({
    value,
    pageDataLength,
    currentPage,
    pagination,
    selectedQA,
    checkAndUncheckQA,
    removeCallback,
  }) => (
    <LiveQAList
      dragData={<DragHandle />}
      key={value.qaid}
      liveqa={value}
      pageDataLength={pageDataLength}
      currentPage={currentPage}
      pagination={pagination}
      selectedQA={selectedQA}
      checkAndUncheckQA={checkAndUncheckQA}
      removeCallback={removeCallback}
    />
  )
);

var SortableList = SortableContainer(
  ({
    items,
    pageDataLength,
    currentPage,
    pagination,
    selectedQA,
    checkAndUncheckQA,
    removeCallback,
  }) => {
    return (
      <div>
        {items.map((value, index) => {
          return (
            <SortableItem
              key={`item-${value.qaid}`}
              index={index}
              value={value}
              pageDataLength={pageDataLength}
              currentPage={currentPage}
              pagination={pagination}
              selectedQA={selectedQA}
              checkAndUncheckQA={checkAndUncheckQA}
              removeCallback={removeCallback}
            />
          );
        })}
      </div>
    );
  }
);

class LiveQA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      allCheck: false,
      actionOption: false,
      selectedQA: [],
      activeLoader: false,
      publishedCount: 0,
      unpublishedCount: 0,
      pageLoader: false,
      liveqarefresh: false,
      loading: true,
      desc: LocaleStrings.preparingLiveQa,
    };
  }

  componentDidMount() {
    this.props.published("published");
    this.props.fetchLiveQA(
      this.props.session,
      this.props.selectedSession,
      0,
      (response) => {
        this.setState({ loading: false });
      }
    );
  }

  clearAllSelectionData = (e) => {
    this.setState({ selectedQA: [], allCheck: false, actionOption: false });
  };

  renderPollList() {
    let {
      livePublishedQAList,
      liveUnpublishedQAList,
      selectedSession,
      selectPublishedType,
    } = this.props;

    if (selectPublishedType && selectPublishedType.ispublished == "published") {
      let pageDataLength =
        livePublishedQAList && livePublishedQAList.resource
          ? livePublishedQAList.resource.length
          : 0;
      let { pageNumber } = this.state;
      return _.map(livePublishedQAList.resource, (qa) => {
        return (
          <LiveQAList
            key={qa.qaid}
            liveqa={qa}
            pageDataLength={pageDataLength}
            currentPage={pageNumber}
            pagination={this.paginationCallback}
            selectedQA={this.state.selectedQA}
            checkAndUncheckQA={this.updateSelectedQA}
            removeCallback={this.removeFromSelectedQA}
          />
        );
      });
    } else {
      let pageDataLength =
        liveUnpublishedQAList && liveUnpublishedQAList.resource
          ? liveUnpublishedQAList.resource.length
          : 0;
      let { pageNumber } = this.state;
      return _.map(liveUnpublishedQAList.resource, (qa) => {
        return (
          <LiveQAList
            key={qa.qaid}
            liveqa={qa}
            pageDataLength={pageDataLength}
            currentPage={pageNumber}
            pagination={this.paginationCallback}
            selectedQA={this.state.selectedQA}
            checkAndUncheckQA={this.updateSelectedQA}
            removeCallback={this.removeFromSelectedQA}
          />
        );
      });
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    let {
      livePublishedQAList,
      liveUnpublishedQAList,
      selectedSession,
      selectPublishedType,
    } = this.props;
    let newArrAvailable = [];
    let checkType = selectPublishedType.ispublished;
    if (selectPublishedType && checkType == "published") {
      let arrAvailable = livePublishedQAList.resource;

      arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

      this.setState({ publishedCount: arrAvailable.length });
      arrAvailable.map((value, index) => {
        newArrAvailable.push({ ...value, displayorder: index + 1 });
      });
    } else {
      let arrAvailable = liveUnpublishedQAList.resource;
      arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);
      this.setState({ unpublishedCount: arrAvailable.length });
      let count = this.state.publishedCount + 1;
      arrAvailable.map((value, index) => {
        newArrAvailable.push({ ...value, displayorder: index + count });
      });
    }

    this.setState({ pageLoader: true });
    this.props.updateLiveQAList(
      this.props.session,
      checkType,
      newArrAvailable,
      (res) => {
        if (res.success) {
          if (checkType == "published") {
            this.props.fetchLiveQA(
              this.props.session,
              this.props.selectedSession,
              this.state.pageNumber,
              (response) => {
                this.setState({ pageLoader: false });
              }
            );
          } else {
            this.props.fetchUnpublishedLiveQA(
              this.props.session,
              this.props.selectedSession,
              this.state.pageNumber,
              (response) => {
                this.setState({ pageLoader: false });
              }
            );
          }
        } else {
        }
      }
    );
  };

  // Removing from selectedQA if exist
  removeFromSelectedQA = (qa) => {
    var selectedQA = this.state.selectedQA;
    var index = _.findIndex(selectedQA, function (curqa) {
      return curqa.qaid === qa.qaid;
    });
    if (index >= 0) {
      var newSelectedQA = _.filter(selectedQA, function (selqa) {
        return selqa.qaid !== qa.qaid;
      });
      this.checkMatchArray(newSelectedQA);
      this.setState({ selectedQA: newSelectedQA });
    }
  };

  // Selecting one one QA
  updateSelectedQA = (qa) => {
    var selectedQA = this.state.selectedQA;

    var index = _.findIndex(selectedQA, function (curqa) {
      return curqa.qaid === qa.qaid;
    });
    if (index >= 0) {
      var newSelectedQA = _.filter(selectedQA, function (selqa) {
        return selqa.qaid !== qa.qaid;
      });
      this.checkMatchArray(newSelectedQA);
      this.setState({ selectedQA: newSelectedQA });
    } else {
      var newSelectQA = { ...qa, checked: true };
      selectedQA = [...selectedQA, newSelectQA];
      this.checkMatchArray(selectedQA);
      this.setState({ selectedQA });
    }
  };

  // Here we are looping to the QA those are visiable on screen only
  selectAllQA = () => {
    var state = this.state.allCheck;
    var selectedQA = this.state.selectedQA;
    var newSelectQA = [];
    var newSelectedQA = [];
    if (
      this.props.selectPublishedType &&
      this.props.selectPublishedType.ispublished == "published"
    ) {
      var allLiveQA = this.props.livePublishedQAList.resource;
    } else {
      var allLiveQA = this.props.liveUnpublishedQAList.resource;
    }

    if (state == false) {
      _.map(allLiveQA, (pubqa) => {
        var checkQAExitOrNot = _.filter(selectedQA, function (selqa) {
          return selqa.qaid === pubqa.qaid;
        });

        //Check if QA is not exist in selected QA that add
        if (checkQAExitOrNot.length == 0) {
          newSelectQA = { ...pubqa, checked: true };
          selectedQA = [...selectedQA, newSelectQA];
        }
        this.checkMatchArray(selectedQA);
        this.setState({ selectedQA });
      });
    } else {
      var leftQA = selectedQA;
      _.map(allLiveQA, (pubqa) => {
        newSelectedQA = _.filter(leftQA, function (selqa) {
          return selqa.qaid !== pubqa.qaid;
        });
        leftQA = newSelectedQA;

        this.checkMatchArray(leftQA);
        this.setState({ selectedQA: leftQA });
      });
    }
  };

  // This function is used to show or hide action option and check or uncheck master check field
  checkMatchArray = (selectedQA) => {
    if (
      this.props.selectPublishedType &&
      this.props.selectPublishedType.ispublished == "published"
    ) {
      var allLiveQA = this.props.livePublishedQAList.resource;
    } else {
      var allLiveQA = this.props.liveUnpublishedQAList.resource;
    }

    var newArray = [];
    _.map(allLiveQA, (qa) => {
      var newSelectedQA = _.filter(selectedQA, function (selqa) {
        return selqa.qaid === qa.qaid;
      });

      // New
      if (newSelectedQA && newSelectedQA.length > 0) {
        newArray = [...newArray, newSelectedQA];
      }
      // Old codes
      // newSelectedQA.length > 0 ? (newArray = [...newArray, newSelectedQA]) : "";
    });

    // Check for current page selection and according to show or hide action option for actions
    if (newArray.length > 0) {
      this.setState({ actionOption: true });
    } else {
      this.setState({ actionOption: false });
    }

    // Check for all user selected or not according to that check or uncheck master check option
    if (newArray.length > 0 && newArray.length === allLiveQA.length) {
      this.setState({ allCheck: true });
    } else {
      this.setState({ allCheck: false });
    }
  };

  makeRefreshTrue = () => {
    this.setState({ liveqarefresh: true });
  };

  paginationCallback = (pageNumber) => {
    let { session, selectedSession } = this.props;
    this.props.fetchLiveQA(
      session,
      selectedSession,
      pageNumber,
      (qaResponse) => {
        if (qaResponse.success) {
          this.props.fetchUnpublishedLiveQA(
            session,
            selectedSession,
            pageNumber,
            (UqaResponse) => {
              this.checkMatchArray(this.state.selectedQA);
              this.setState({ liveqarefresh: false });
            }
          );
        }
      }
    );
    this.setState({ ...this.state, pageNumber });
  };

  markImportantUnimp = (key) => {
    this.setState({ activeLoader: true });
    var QA = this.state.selectedQA;
    if (key === "imp_selected") {
      this.props.markBulkImportant(
        this.props.session,
        QA,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_selected_qa_marked_imp
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    } else {
      this.props.markBulkUnimportant(
        this.props.session,
        QA,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_selected_qa_marked_unimp
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    }
  };

  markAllImportantUnimp = (key) => {
    this.setState({ activeLoader: true });
    if (key === "imp_all") {
      this.props.markAllImportant(
        this.props.session,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_all_qa_marked_imp
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    } else {
      this.props.markAllUnimportant(
        this.props.session,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_all_qa_marked_unimp
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    }
  };

  markUnpub = (key) => {
    let { selectedQA, pageNumber } = this.state;

    /**
     * Calculation for current page no. in pageination select
     */
    let leftRecord =
      this.props.livePublishedQAList.count - this.state.selectedQA.length;
    var pageCount = Math.floor(leftRecord / itemCount);
    var pageExtraCount = Math.floor(leftRecord % itemCount);

    if (pageExtraCount > 0) {
      pageCount = pageCount + 1;
    }

    let newPageNo = pageNumber;
    if (pageNumber > pageCount) {
      newPageNo = pageCount;
    }

    this.setState({ activeLoader: true });
    if (key === "unpub_selected") {
      this.props.markBulkUnpub(
        this.props.session,
        selectedQA,
        newPageNo,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_selected_qa_marked_unpub
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    } else {
      this.props.markAllUnpub(
        this.props.session,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_all_qa_marked_unpub
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    }
  };

  markPub = (key) => {
    let { selectedQA, pageNumber } = this.state;

    /**
     * Calculation for current page no. in pageination select
     */
    let leftRecord =
      this.props.liveUnpublishedQAList.count - this.state.selectedQA.length;
    var pageCount = Math.floor(leftRecord / itemCount);
    var pageExtraCount = Math.floor(leftRecord % itemCount);

    if (pageExtraCount > 0) {
      pageCount = pageCount + 1;
    }

    let newPageNo = pageNumber;
    if (pageNumber > pageCount) {
      newPageNo = pageCount;
    }

    this.setState({ activeLoader: true });
    if (key === "pub_selected") {
      this.props.markBulkPub(
        this.props.session,
        selectedQA,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_selected_qa_marked_pub
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    } else {
      this.props.markAllPub(
        this.props.session,
        this.state.pageNumber,
        this.props.selectedSession,
        (response) => {
          this.setState({ activeLoader: false });
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_text_all_qa_marked_pub
            );
            this.clearAllSelectionData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.clearAllSelectionData();
          }
        }
      );
    }
  };

  exportLiveQA = (JSONData, ShowLabel) => {
    this.JSONToCSVConvertor(JSONData, ShowLabel);
  };

  JSONToCSVConvertor(JSONData, ShowLabel) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

    var CSV = "";

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = "Question\n";
      _.map(arrData, (item) => {
        row += item.liveqa_question + "\n";
      });
      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + "\r\n";
    }

    if (CSV == "") {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "LiveQA";

    //Initialize file format you want csv or xls
    var uri = "data:text/csv;charset=utf-8," + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    var link = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * =============================================================================================
   */

  render() {
    let {
      livePublishedQAList,
      liveUnpublishedQAList,
      selectedSession,
      selectPublishedType,
      deviceSize,
    } = this.props;
    var { pageLoader } = this.state;

    let totalCount =
      selectPublishedType && selectPublishedType.ispublished == "published"
        ? livePublishedQAList.count
        : liveUnpublishedQAList.count;
    let emptyMessage =
      selectPublishedType && selectPublishedType.ispublished == "published"
        ? NO_PUBLISHED_QA
        : NO_UNPUBLISHED_QA;

    let pubStyle = { display: "block" };
    let unPubStyle = { display: "none" };
    if (selectPublishedType && selectPublishedType.ispublished == "published") {
      unPubStyle = { display: "block" };
      pubStyle = { display: "none" };
    }
    if (selectPublishedType && selectPublishedType.ispublished == "published") {
      var pageDataLength =
        livePublishedQAList && livePublishedQAList.resource
          ? livePublishedQAList.resource.length
          : 0;
      var { pageNumber } = this.state;
    } else {
      var pageDataLength =
        liveUnpublishedQAList && liveUnpublishedQAList.resource
          ? liveUnpublishedQAList.resource.length
          : 0;
      var { pageNumber } = this.state;
    }

    var classCustom = "";
    if (pageLoader) {
      classCustom = "page-loading";
    }

    return (
      <div className={this.state.activeLoader ? "user_main_div" : ""}>
        <div className="content-header-bar">
          <div className="vertical-align-center gap-1 flex-grow-1">
            <PollIcon
              heading={HEADING_LIVEQA}
              clearAllSelectionData={this.clearAllSelectionData}
              pagination={this.paginationCallback}
              loadingrefresh={this.makeRefreshTrue}
              isqarefresh={this.state.liveqarefresh}
            />
          </div>

          <ul className="header-buttons">
            <li>
              <AddLiveQA history={this.props.history} />
            </li>
            {/* <li className="schedule-button">
                <ExportLiveQA JSONToCSVConvertor={this.exportLiveQA} />
              </li> */}
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              {totalCount > 0 ? (
                <div>
                  <div className="container-fluid">
                    <div
                      className="row mb-10 ml-0"
                      style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
                    >
                      <div
                        className="row mb-10"
                        style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
                      >
                        <div className="col-md-1" style={{ display: "flex" }}>
                          <label className="custom-container-checkbox d-inline-block">
                            <input
                              type="checkbox"
                              onChange={this.selectAllQA}
                              checked={this.state.allCheck}
                            />
                            <span className="checkmark" />
                          </label>

                          {this.state.actionOption === true ? (
                            <div
                              className="dropdown-btn-container"
                              style={{ marginTop: "-2px" }}
                            >
                              <DropdownButton
                                className="dropdown-blue-carret-btn"
                                title=""
                                key="1"
                                id="dropdown-basic-2"
                                // bsSize="xsmall"
                                nocaret="true"
                              >
                                <Dropdown.Item
                                  eventKey="imp_selected"
                                  onClick={() =>
                                    this.markImportantUnimp("imp_selected")
                                  }
                                >
                                  {LocaleStrings.polls_qa_mark_imp_selected}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  eventKey="unimp_selected"
                                  onClick={() =>
                                    this.markImportantUnimp("unimp_selected")
                                  }
                                >
                                  {LocaleStrings.polls_qa_mark_unimp_selected}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  eventKey="imp_all"
                                  onClick={() =>
                                    this.markAllImportantUnimp("imp_all")
                                  }
                                >
                                  {LocaleStrings.polls_qa_mark_imp_all}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  eventKey="unimp_all"
                                  onClick={() =>
                                    this.markAllImportantUnimp("unimp_all")
                                  }
                                >
                                  {LocaleStrings.polls_qa_mark_unimp_all}
                                </Dropdown.Item>

                                <Dropdown.Item
                                  eventKey="unpub_selected"
                                  onClick={() =>
                                    this.markUnpub("unpub_selected")
                                  }
                                  style={unPubStyle}
                                >
                                  {LocaleStrings.polls_qa_mark_unpub_selected}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  eventKey="unpub_all"
                                  onClick={() => this.markUnpub("unpub_all")}
                                  style={unPubStyle}
                                >
                                  {LocaleStrings.polls_qa_mark_unpub_all}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  eventKey="pub_selected"
                                  onClick={() => this.markPub("pub_selected")}
                                  style={pubStyle}
                                >
                                  {LocaleStrings.polls_qa_mark_pub_selected}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  eventKey="pub_all"
                                  onClick={() => this.markPub("pub_all")}
                                  style={pubStyle}
                                >
                                  {LocaleStrings.polls_qa_mark_pub_all}
                                </Dropdown.Item>
                              </DropdownButton>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-lg-6 col-sm-3">
                          {LocaleStrings.polls_qa_table_list_qestions}
                        </div>
                        <div className="col-lg-2 col-sm-3">
                          {LocaleStrings.polls_qa_table_list_replies}
                        </div>
                        <div className="col-md-3">
                          {LocaleStrings.polls_qa_table_list_action}
                        </div>
                      </div>

                      <div
                        className={`col-md-12 ${classCustom}`}
                        style={{
                          backgroundColor: "#ffffff",
                          backfaceVisibility: "hidden",
                          willChange: "transform",
                          userSelect: "none",
                          WebkitUserSelect: "none",
                          titleBarStyle: "hidden",
                        }}
                      >
                        {/* {this.renderPollList()} */}
                        {selectPublishedType &&
                        selectPublishedType.ispublished == "published" ? (
                          <SortableList
                            useDragHandle
                            items={livePublishedQAList.resource}
                            onSortEnd={this.onSortEnd}
                            //pressDelay={200}
                            axis="y"
                            lockAxis="y"
                            pageDataLength={pageDataLength}
                            currentPage={pageNumber}
                            pagination={this.paginationCallback}
                            selectedQA={this.state.selectedQA}
                            checkAndUncheckQA={this.updateSelectedQA}
                            removeCallback={this.removeFromSelectedQA}
                          />
                        ) : (
                          <SortableList
                            useDragHandle
                            items={liveUnpublishedQAList.resource}
                            onSortEnd={this.onSortEnd}
                            //pressDelay={200}
                            axis="y"
                            lockAxis="y"
                            pageDataLength={pageDataLength}
                            currentPage={pageNumber}
                            pagination={this.paginationCallback}
                            selectedQA={this.state.selectedQA}
                            checkAndUncheckQA={this.updateSelectedQA}
                            removeCallback={this.removeFromSelectedQA}
                          />
                        )}
                      </div>
                    </div>

                    {totalCount > 50 ? (
                      <Pagination
                        activePage={this.state.pageNumber}
                        itemsCountPerPage={50}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={10}
                        onChange={this.paginationCallback}
                        style={{ float: "right" }}
                      />
                    ) : null}
                  </div>
                </div>
              ) : (
                <NoContent contentType={emptyMessage} />
              )}
            </>
          )}
        </div>
        <BroadCastLiveQA selectedSession={selectedSession} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    selectedSession: state.selectedSession.resource,
    selectPublishedType: state.selectPublishedType,
    livePublishedQAList: state.livePublishedQAList,
    liveUnpublishedQAList: state.liveUnpublishedQAList,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  published,
  fetchLiveQA,
  fetchUnpublishedLiveQA,
  markBulkImportant,
  markBulkUnimportant,
  markAllImportant,
  markAllUnimportant,
  markBulkUnpub,
  markAllUnpub,
  markBulkPub,
  markAllPub,
  showError,
  showSuccess,
  updateLiveQAList,
})(LiveQA);
